import { render, staticRenderFns } from "./ImportDialog.vue?vue&type=template&id=2488faef"
import script from "./ImportDialog.vue?vue&type=script&lang=js"
export * from "./ImportDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports